import { FormControl, SelectChangeEvent } from '@mui/material';
import { MenuItem } from '@sortlist-frontend/design-system/legacy';
import { useTranslation } from '@sortlist-frontend/translation/ssr';
import { useRouter } from 'next/router';
import { Dispatch, FC, SetStateAction } from 'react';

import { customConfig } from '_features/custom/custom.config';
import * as S from '_features/stories/components/stories-sorter/stories-sorter.component.styles';
import {
  BusinessOptions,
  StoriesTypeProp,
  StoryOptionCountry,
  StoryOptionType,
  titleCase,
} from '_features/stories/utils';

export type StoriesSorterProps = {
  optionsType?: StoriesTypeProp[];
  optionCountry?: StoriesTypeProp[];
  setSelectedType: Dispatch<SetStateAction<StoriesTypeProp>>;
  selectedType: StoriesTypeProp;
  selectedCountry: StoriesTypeProp;
  setSelectedCountry: Dispatch<SetStateAction<StoriesTypeProp>>;
};

export const StoriesSorter: FC<StoriesSorterProps> = (props) => {
  const router = useRouter();
  const { optionsType, setSelectedType, selectedType, optionCountry, selectedCountry, setSelectedCountry } = props;
  const { t } = useTranslation(customConfig.i18nNamespaces);

  const routerHandler = () => {
    delete router.query.category;
    delete router.query.country;
    router.push(router.query.lang ? (`/${router.query.lang}/stories` as any) : '/stories', undefined, {
      shallow: true,
    }); // push to a clean path /stories if we are using the sorting component and not the url params
  };

  const handleType = (event: SelectChangeEvent<unknown>) => {
    routerHandler();
    setSelectedType({ key: event.target?.value as string, label: event.target?.value as string });
  };

  const handleCountry = (event: SelectChangeEvent<unknown>) => {
    routerHandler();
    setSelectedCountry({ key: event.target?.value as string, label: event.target?.value as string });
  };

  return (
    <section className="max-sm:mt-8" data-testid="stories-sorter">
      <div className="layout-row layout-align-end-center container-lg">
        <FormControl className="layout-align-start-center" sx={{ flexDirection: 'row' }}>
          <label id={BusinessOptions.CATEGORY} className="p">
            {t('stories:sorter.category')}
          </label>

          <S.SorterSelect
            labelId={BusinessOptions.CATEGORY}
            aria-labelledby={BusinessOptions.CATEGORY}
            value={selectedType.key}
            onChange={handleType}
            sx={{ fontWeight: 700, lineHeight: '1.5rem' }}>
            {optionsType?.map((option, index) => {
              const capitalizeOption = titleCase(option.label);
              return (
                <MenuItem key={`${option.key}-${index}`} value={option.key as StoryOptionType}>
                  {capitalizeOption}
                </MenuItem>
              );
            })}
          </S.SorterSelect>
        </FormControl>
        <FormControl className="layout-align-start-center" sx={{ flexDirection: 'row' }}>
          <label id={BusinessOptions.COUNTRY} className="p">
            {t('stories:sorter.country')}
          </label>
          <S.SorterSelect
            labelId={BusinessOptions.COUNTRY}
            aria-labelledby={BusinessOptions.COUNTRY}
            value={selectedCountry.key}
            onChange={handleCountry}
            sx={{ fontWeight: 700, lineHeight: '1.5rem' }}>
            {optionCountry?.map((option, index) => {
              return (
                <MenuItem key={`${option.key}-${index}`} value={option.key as StoryOptionCountry}>
                  {option.key === 'all' ? option.label : option.label.toUpperCase()}
                </MenuItem>
              );
            })}
          </S.SorterSelect>
        </FormControl>
      </div>
    </section>
  );
};
